export const USER_GROUP = Object.freeze({
	MAINTAINER: 999,
	ADMIN: 99,
	USER: 10,
	PUBLIC: 0,
});

export const RAW_STATUS = Object.freeze({
	PUBLISHED: 30,
	APPROVED: 20,
	CREATED: 0,
	REJECTED: -10,
	DELETED: -20,
});

export const GRAPH_STATUS = Object.freeze({
	PUBLIC: 1,
	REQUIRED_LOGIN: 10,
	HIDDEN: -10,
});

export const AUDIT_TYPE = Object.freeze({
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILED: 'LOGIN_FAILED',
	LOGIN_DISABLED: 'LOGIN_DISABLED',

	USERINFO_CHANGED: 'USERINFO_CHANGED',
	PASSWD_CHANGED: 'PASSWD_CHANGED',
	USER_ADDED: 'USER_ADDED',
	USER_ENABLED: 'USER_ENABLED',
	USER_DISABLED: 'USER_DISABLED',
	USER_GRANTED: 'USER_GRANTED',
	USER_REVOKED: 'USER_REVOKED',
	USER_DELETED: 'USER_DELETED',
	USER_RESTORED: 'USER_RESTORED',

	// TABLE_ADDED: 'TABLE_ADDED',
	TABLE_EDITOR_UPDATED: 'TABLE_EDITOR_UPDATED',
	TABLE_REVIEWER_UPDATED: 'TABLE_REVIEWER_UPDATED',
	TABLE_SET_PUBLIC: 'TABLE_SET_PUBLIC',
	TABLE_SET_PRIVATE: 'TABLE_SET_PRIVATE',
	TABLE_ENABLED: 'TABLE_ENABLED',
	TABLE_DISABLED: 'TABLE_DISABLED',

	DOC_ADDED: 'DOC_ADDED',
	DOC_APPROVED: 'DOC_APPROVED',
	DOC_PUBLISHED: 'DOC_PUBLISHED',
	DOC_REJECTED: 'DOC_REJECTED',
	DOC_EDITED: 'DOC_EDITED',
	DOC_DELETED: 'DOC_DELETED',
	DOC_DELETE_ALL: 'DOC_DELETE_ALL',

	GRAPH_SET_PRIVATE: 'GRAPH_SET_PRIVATE',
	GRAPH_SET_PUBLIC: 'GRAPH_SET_PUBLIC',
	GRAPH_SET_NAME: 'GRAPH_SET_NAME',
	GRAPH_SET_ORDER: 'GRAPH_SET_ORDER',
});

export const PREPARE_STATUS = Object.freeze({
	SERVER_ERROR: -99,
	DATA_ERROR: -1,
	NO_CHANGE: 0.1,
	INSERT: 1,
	UPDATE: 2,
});

export const ADMINISTRATIVE_AREA = Object.freeze({
	全區域: '全區域',
	板橋區: '板橋區',
	三重區: '三重區',
	中和區: '中和區',
	永和區: '永和區',
	新莊區: '新莊區',
	新店區: '新店區',
	樹林區: '樹林區',
	鶯歌區: '鶯歌區',
	三峽區: '三峽區',
	淡水區: '淡水區',
	汐止區: '汐止區',
	瑞芳區: '瑞芳區',
	土城區: '土城區',
	蘆洲區: '蘆洲區',
	五股區: '五股區',
	泰山區: '泰山區',
	林口區: '林口區',
	深坑區: '深坑區',
	石碇區: '石碇區',
	坪林區: '坪林區',
	三芝區: '三芝區',
	石門區: '石門區',
	八里區: '八里區',
	平溪區: '平溪區',
	雙溪區: '雙溪區',
	貢寮區: '貢寮區',
	金山區: '金山區',
	萬里區: '萬里區',
	烏來區: '烏來區',
});

export const REVIEW_MODE = Object.freeze({
	DEFAULT: 0,
	APPROVE: 1,
	PUBLISH: 3,
	REJECT: 2,
	ERROR: -1,
});

export const BROWSE_MODE = Object.freeze({
	DEFAULT: 0,
	SELF_UPLOAD: 1,
	WAIT_REVIEW: 2,
	WAIT_REVIEW_MYDEPT: 3,
	UNPUBLISHED: 4,
});

export const EDIT_DATA_STATUS = Object.freeze({
	DEFAULT: 0,
	LOADING: 1,
	SUCCESS: 2,
	ERROR: -1,
});

export const ACTION_MESSAGE = Object.freeze({
	REVIEW_ERROR_409: '欲審核的資料含有錯誤數值，請檢查資料後再試一次',
	REVIEW_ERROR_DEFAULT: '目前無法進行審核，請稍後再試一次',
});
